import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

export const GalleryLoading: React.FC = () => {
  return (
    <Box width="100%" height="100%">
      <SkeletonLoader height="100%" />
    </Box>
  )
}
